<template>
    <div class="address-list-page">
        <van-sticky>
            <van-nav-bar
                :style="{'paddingTop':statusBarHeight,'backgroundColor':'#FFFFFF'}"
                title="我的地址"
                left-arrow
                @click-left="handleBack"
            />
        </van-sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="returnData">
            <van-list
                v-model="loading"
                :finished="finished"
                loading-text="加载中"
                :finished-text="filter.pageNum != 1 && addressList.length? '-没有更多了-' : ''"
                :error.sync="error"
                error-text="加载失败，重试"
                :immediate-check="false"
                @load="onLoad"
            >
                <van-address-list
                    v-model="chosenAddressId"
                    :list="addressList"
                    default-tag-text="默认"
                    add-button-text="添加收货地址"
                    @add="handleAdd"
                    @edit="handleEdit"
                    @select="handleSelect"
                />
                <empty v-if="!addressList.length" />
            </van-list>
        </van-pull-refresh>
        <div class="add-btn-box" @click="handleAdd" :style="{'paddingBottom':bottomSafeHeight,'backgroundColor':'#FFFFFF'}">
            <div class="add-btn"><i class="icon icon-address"></i> 添加收货地址</div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState(["userInfo"]),
    },
    data() {
        return {
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            statusBarHeight: 0,
            bottomSafeHeight: 0,
            refreshing: false,
            error: false,
            loading: true,
            finished: false,
            total: 0,
            filter: {
                pageNum: 1,
                pageSize: 10,
            },
            chosenAddressId: '',
            addressList: [],
            uuid: this.$route.query.uuid || '',
            num: this.$route.query.num || '',
            goodsKinds: this.$route.query.goodsKinds || '',
            id: this.$route.query.id || '',
            returnData: false
        }
    },
    created() {
        this.setCompatible();
        this.getDataList();
    },
    methods: {
        setCompatible() {
            if(localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
                this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
            }
        },
        getDataList() {
            let addressList = []
            this.$api.address.getAddressList(this.filter).then((res)=>{
                this.returnData = true;
                if(res.success) {
                    this.error = false;
                    if (this.refreshing) {
                        this.listData = [];
                        this.refreshing = false;
                    }
                    const {list, total} = res.data;
                    if(this.filter.pageNum === 1) {
                        addressList = list;
                    } else {
                        addressList = addressList.concat(list);
                    }
                    this.loading = false;
                    if(addressList.length >= total) {
                        this.loading = false;
                        this.finished = true;
                    } else {
                        this.filter.pageNum++;
                    }
                    this.formataData(addressList)
                } else {
                    this.error = true;
                    this.loading = false;
                }
            },()=>{
                this.error = true;
                this.loading = false;
            })
        },
        formataData(list) {
            this.addressList = list.map(item=>{
                const {province,city, area, addr, receiver, mobile} = item
                return {
                    id: item.id,
                    name: receiver,
                    tel: mobile,
                    province,
                    address: `${province}${city}${area} ${addr}`,
                    isDefault: item.defaultFlag == 0 ? false : true,
                    city,
                    area,
                    addr,
                    mobile,
                    receiver,
                }
            })
        },
        handleEdit(data) {
            const { id } = data;
            let url = `/address/edit/${id}`;
            if(this.uuid) {
                if (this.goodsKinds == 5) {
                    url = `${url}?uuid=${this.uuid}&num=${this.num}&goodsKinds=5&id=${this.id}`
                } else {
                    url = `${url}?uuid=${this.uuid}&num=${this.num}`
                }
            }
            this.$router.push(url);
        },
        handleAdd() {
            let url = `/address/add`;
            if(this.uuid) {
                if (this.goodsKinds == 5) {
                    url = `${url}?uuid=${this.uuid}&num=${this.num}&goodsKinds=5&id=${this.id}`
                } else {
                    url = `${url}?uuid=${this.uuid}&num=${this.num}`
                }
            }
            this.$router.push(url);
        },
        handleSelect(item, index) {
            if(this.uuid) {
                localStorage.setItem(`address_${this.userInfo.id}`, JSON.stringify(this.addressList[index]))
                if (this.goodsKinds == 5) {
                    // 组合商品
                    this.$router.replace(`/confirmOrder/${this.uuid}?id=${this.id}&num=${this.num}`)
                } else {
                    this.$router.replace(`/order/index/${this.uuid}?num=${this.num}`)
                }
            }
        },
        onLoad() {
            this.getDataList();
        },
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.filter.pageNum = 1;
            this.onLoad();
        },
        handleBack() {
            if(this.uuid) {
                if (this.goodsKinds == 5) {
                    // 组合商品
                    this.$router.replace(`/confirmOrder/${this.uuid}?id=${this.id}&num=${this.num}`);
                } else {
                    this.$router.replace(`/order/index/${this.uuid}?num=${this.num}`);
                }
            } else {
                this.$router.go(-1)
            }
        }
    },
}
</script>
<style lang="less">
    html,body {
        background-color: #fff;
    }
</style>

<style lang="less" scoped>
    .px2rem(@name,@px){
        @{name}: @px / 37.5px * 1rem
    }
    ::v-deep {
        .van-address-list__bottom {
            display: none
        }
        .van-address-list {
            padding-top: 0;
            .px2rem(padding-right, 32);
            .px2rem(padding-bottom, 32);
            .px2rem(padding-left, 32);

        }
        .van-address-item {
            padding: 0;
            .px2rem(padding-top, 32);
            .px2rem(padding-bottom, 32);
            border-bottom: 1px solid #EAEAEA;
            border-radius: 0;
            margin-bottom: 0;
            .van-radio__label {
                margin-left: 0;
            }
        }
        .van-radio__icon{
            display: none;
        }
        .van-tag {
            padding: 0;
            background: rgba(31, 148, 255, 0.12);
            color: #1F94FF;
            text-align: center;
            .px2rem(height, 36);
            .px2rem(padding-left, 20);
            .px2rem(padding-right, 20);
            .px2rem(border-radius, 4);
        }
        .van-address-item__name {
            .px2rem(margin-bottom, 12);
            .px2rem(font-size, 30);
            font-family: AvenirNext-DemiBold, AvenirNext;
            font-weight: 600;
        }
        .van-address-item__address {
            color: #999;
            .px2rem(font-size, 26);
        }
        .van-address-list__bottom {
            box-sizing: border-box;
            background-color: #fff;
            box-shadow: inset 0px 1px 0px 0px #EAEAEA;
            .px2rem(padding-top, 9);
            .px2rem(padding-right, 32);
            .px2rem(padding-bottom, 9);
            .px2rem(padding-left, 32);
            .van-button {
                background-color: #1F94FF;
                border-color: #1F94FF;
            }
        }
        .van-icon-edit {
            position: absolute;
            top: 50%;
            width: 50px;
            height: 50px;
            right: 0;
            &::before {
                content: '';
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                .px2rem(height, 30);
                .px2rem(width, 30);
                background: url(../asset/images/icon_edit.png) no-repeat center right /100% 100%;
            }
        }
    }
    .address-list-page {
        min-height: 100vh;
        background-color: #fff;
    }
    .add-btn-box {
        position: fixed;
        bottom: 0;
        padding: 9px 32px;
        box-shadow: inset 0px 1px 0px 0px #EAEAEA;
        width: 100%;
        box-sizing: border-box;
        .add-btn {
            height: 80px;
            background-color: #1F94FF;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            flex: 1;
            border-radius: 44px;
            margin-bottom: 9px;
            font-size: 30px;
            .icon {
                width: 20px;
                height: 20px;
                background: url('../asset/images/icon_add_address.png') no-repeat center center /100% 100%;
                display: inline-block;
                margin-right: 6px;
            }
        }
    }
</style>